import { render, staticRenderFns } from "./cancel-pending-investment.component.vue?vue&type=template&id=c58b4608&"
import script from "./cancel-pending-investment.component.vue?vue&type=script&lang=ts&"
export * from "./cancel-pending-investment.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports